import { createContext } from "react";

export const MagicSvgContext = createContext({
  userToken: {},
  image: {},
  recentImages: [],
  generationStatus: '',
  deliveryStatus: '',
});

export const MagicSvgDispatchContext = createContext(null);
